import apiSferest from '@/api/apiSferest/services/login'
import apiLogin from '@/api/apiLogin/services/login'
import session from './session'

const authenticate = (authorization, options = {}) => {
  let data = options.data || {}
  let retries = options.retries || undefined
  let support = options.support || false

  return apiSferest.login(authorization, data)
    .then(result => {
      let data = result.data
      if (session.isSupportSession()) return Promise.resolve()
      if (!data.token) return Promise.reject(new Error('Token is missing from response'))
      session.save(data, support)
      return Promise.resolve(data)
    }, err => {
      if (!retries) return Promise.reject(err)
      if (retries.length < 1) return Promise.reject(new Error('Maximum number of retries reached.'))
      let timeout = retries.shift()
      return setTimeout(() => {
        let options = {data: data, retries: retries}
        return authenticate(authorization, options)
      }, timeout)
    })
}

const authenticateNew = (authorizationBody) => {
  return apiLogin.login(authorizationBody)
    .then(result => {
      let data = result.data
      if (!data.access_token) return Promise.reject(new Error('Token is missing from response'))
      session.saveNew(data)
      return Promise.resolve(data)
    }, err => {
      return Promise.reject(err)
    })
}

const refreshAuthenticateNew = () => {
  let authorizationBody = {
    grant_type: 'refresh_token',
    refresh_token: session.getValue('efactura_refresh_token')
  }
  return apiLogin.login(authorizationBody)
    .then(result => {
      let data = result.data
      if (!data.access_token) return Promise.reject(new Error('Not possible to refresh token'))
      session.saveNew(data)
      return Promise.resolve(data)
    }, err => {
      return Promise.reject(err)
    })
}

export default {
  authenticate,
  authenticateNew,
  refreshAuthenticateNew
}
